export default "__VITE_ASSET__01068ad2__"